@for (option of options; track option.value) {
    <label class="container_radio">
        {{ option.label }}
        <input
            class="w-1"
            type="radio"
            [value]="option"
            [checked]="value() === option.value"
            (change)="selectOption(option.value)" />
        <span class="checkmark"></span>
    </label>
}
